import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Department } from '@tcaster/tcaster-web-lib';
import _throttle from 'lodash/throttle';
import _debounce from 'lodash/debounce';
import ReactGA from 'react-ga';

import { Flex, Box, Text } from '../Base';
import { COLOR } from '../Theme';

import HeartButton from './HeartButton';

const Link = styled(Text)`
  cursor: pointer;
  padding-right: 16px;
  &:hover {
    color: ${COLOR.primary};
    text-decoration: underline;
  }
`;

const Stamp = styled(Box)`
  margin-left: -8px;
  width: 80px;
  height: 60px;
  background: url('images/confirm/stamped.png') center center no-repeat;
  background-size: contain;
`;

class DepartmentItem extends Component {
  handleFavClick = _throttle(() => {
    this.props.onFavToggle(this.props.id, this.props.favAdded);
    try {
      ReactGA.event({
        category: 'DEPARTMENT_ITEM',
        action: this.props.added ? 'Fav Dept remove' : 'Fav Dept added',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
  }, 1000);

  handleAddDepartment = _throttle(() => {
    this.props.onUpdateDepartment(this.props.id);
  }, 1000);

  handleSelect = _debounce(
    () => {
      this.props.onSelectDeparmentId(this.props.id);
    },
    1000,
    { leading: true, trailing: false },
  );

  renderAction = () => {
    const {
      favAdded,
      favLoading,
      favDisableAdd,
      favDisabled,
      favDisabledText,
      mockExam,
      hideHeart,
      isSelectMode,
      isConfirmedAdmission,
    } = this.props;
    if (mockExam) {
      return (
        <Link is="a" color="primary" onClick={this.handleAddDepartment}>
          เลือก
        </Link>
      );
    }
    if (isConfirmedAdmission) {
      return <Stamp />;
    }

    if (isSelectMode) {
      return (
        <Link is="a" color="primary" onClick={this.handleSelect}>
          เลือก
        </Link>
      );
    }

    return (
      hideHeart || (
        <HeartButton
          added={favAdded}
          loading={favLoading}
          disabled={favDisabled || (favDisableAdd && !favAdded)}
          disabledText={favDisabledText}
          onClick={this.handleFavClick}
        />
      )
    );
  };

  render() {
    const { notFound, ...restProps } = this.props;
    return (
      <Flex>
        <Box flex="1 1 auto">
          {notFound ? (
            <Text.Title>ไม่มีคณะนี้อยู่ในระบบ</Text.Title>
          ) : (
            <Department {...restProps} />
          )}
        </Box>
        <Flex flex="0 0 24px" justifyContent="center" alignItems="flex-start">
          {this.renderAction()}
        </Flex>
      </Flex>
    );
  }
}

DepartmentItem.propTypes = {
  favAdded: PropTypes.bool,
  favLoading: PropTypes.bool,
  favDisableAdd: PropTypes.bool,
  favDisabled: PropTypes.bool,
  favDisabledText: PropTypes.string,
  onFavToggle: PropTypes.func,
  onSelectDeparmentId: PropTypes.func,
};

DepartmentItem.defaultProps = {
  onFavToggle: () => {},
  onSelectDeparmentId: () => {},
};

export default DepartmentItem;
